import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { SprintMoveDirection } from '../../../../model/types.tsx';
import {
	type OptimisticId,
	type OptimisticUiMeta,
	type OptimisticUiMetaWithFlag,
	beginOptimisticUiMeta,
	commitOptimisticUiMeta,
	revertOptimisticUiWithFlagMeta,
} from '../../meta/optimistic-ui-meta.tsx';

export const SPRINT_MOVE_REQUEST = 'state.actions.sprints.move.SPRINT_MOVE_REQUEST' as const;

type SprintMoveRequestActionPayload = {
	sprintId: string;
	targetSprintId: string;
	direction: SprintMoveDirection;
	analyticsEvent: UIAnalyticsEvent;
};

export type SprintMoveRequestAction = {
	type: typeof SPRINT_MOVE_REQUEST;
	payload: SprintMoveRequestActionPayload;
	meta: OptimisticUiMeta;
};

export const sprintMoveRequest = (
	payload: SprintMoveRequestActionPayload,
): SprintMoveRequestAction => ({
	type: SPRINT_MOVE_REQUEST,
	payload,
	meta: beginOptimisticUiMeta(),
});

export const SPRINT_MOVE_SUCCESS = 'state.actions.sprints.move.SPRINT_MOVE_SUCCESS' as const;

export type SprintMoveSuccessAction = {
	type: typeof SPRINT_MOVE_SUCCESS;
	meta: OptimisticUiMeta;
};

export const sprintMoveSuccess = (optimisticId: OptimisticId): SprintMoveSuccessAction => ({
	type: SPRINT_MOVE_SUCCESS,
	meta: commitOptimisticUiMeta(optimisticId),
});

export const SPRINT_MOVE_FAILURE = 'state.actions.sprints.move.SPRINT_MOVE_FAILURE' as const;

export type SprintMoveFailureAction = {
	type: typeof SPRINT_MOVE_FAILURE;
	meta: OptimisticUiMetaWithFlag;
};

export const sprintMoveFailure = (optimisticId: OptimisticId): SprintMoveFailureAction => ({
	type: SPRINT_MOVE_FAILURE,
	meta: revertOptimisticUiWithFlagMeta(optimisticId),
});

export type Action = SprintMoveRequestAction | SprintMoveSuccessAction | SprintMoveFailureAction;
